<template>
  <div class="app-container">
    <CrudTable entity="Workshop" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'code', label: 'workshop.code', width: '140px' },
        { field: 'name', label: 'common.name', width: '300px' },
        { field: 'stockLocationName', label: 'workshop.stockLocationName' }
      ]
    };
  },
  methods: {
    generateSummary({ name }) {
      return `${name}`;
    }
  }
};
</script>
